import component from './CombiHeating.vue';
import { StepCategoryId, StepId } from '~/consts/assistant-steps';
import {
  FormMultipleChoiceComponentConfig,
  FormMultipleChoiceValueType,
  StepDefinition,
} from '@/interfaces/step-definition';
import { AssistantStepContext } from '@/interfaces/context';
import { FormFieldType } from '@/consts/input-types';
import { FormFieldGroupId } from '~/consts/assistant-form-field-groups';

export interface CombiHeatingStepContext extends AssistantStepContext {
  heatingType: FormMultipleChoiceValueType;
  currentUse: FormMultipleChoiceValueType;
  distribution: FormMultipleChoiceValueType;
}

const config: StepDefinition = {
  component,
  isDisabled: (context) =>
    !context.combiInterest?.combiInterest?.includes('heat-pump'),
  hideSkipMessage: () => true,
  fields: [
    {
      component: {
        columns: 4,
        hideCheckbox: true,
        options: [
          {
            value: 'gas',
            image: {
              file: 'img/icon/gas.svg',
              options: {
                height: 50,
                width: 50,
              },
            },
          },
          {
            value: 'electricity',
            image: {
              file: 'img/icon/electricity.svg',
              options: {
                height: 50,
                width: 50,
              },
            },
          },
          {
            value: 'oil',
            image: {
              file: 'img/icon/oil.svg',
              options: {
                height: 50,
                width: 50,
              },
            },
          },
          {
            value: 'other',
            image: {
              file: 'img/icon/other.svg',
              options: {
                height: 50,
                width: 50,
              },
            },
          },
        ],
        singleAnswer: true,
        verticalOptionLayout: true,
      } as FormMultipleChoiceComponentConfig,
      name: 'heatingType',
      required: true,
      type: FormFieldType.MultipleChoice,
      groupId: FormFieldGroupId.HEATER,
    },
    {
      component: {
        columns: 4,
        hideCheckbox: true,
        options: [
          {
            value: 'heatHotwater',
            image: {
              file: 'img/icon/space-heating-1.svg',
              options: {
                height: 50,
                width: 50,
              },
            },
          },
          {
            value: 'spaceHeating',
            image: {
              file: 'img/icon/space-heating-2.svg',
              options: {
                height: 50,
                width: 50,
              },
            },
          },
        ],
        singleAnswer: true,
        verticalOptionLayout: true,
      } as FormMultipleChoiceComponentConfig,
      name: 'currentUse',
      required: true,
      type: FormFieldType.MultipleChoice,
      groupId: FormFieldGroupId.HOUSEHOLD,
    },
    {
      component: {
        columns: 4,
        hideCheckbox: true,
        options: [
          {
            value: 'radiator',
            image: {
              file: 'img/icon/radiator.svg',
              options: {
                height: 50,
                width: 50,
              },
            },
          },
          {
            value: 'underfloorHeating',
            image: {
              file: 'img/icon/floor-heating.svg',
              options: {
                height: 50,
                width: 50,
              },
            },
          },
        ],
        // singleAnswer: true,
        verticalOptionLayout: true,
      } as FormMultipleChoiceComponentConfig,
      name: 'distribution',
      required: true,
      type: FormFieldType.MultipleChoice,
      groupId: FormFieldGroupId.HOUSEHOLD,
    },
  ],
  id: StepId.COMBI_HEATING,
  categoryId: StepCategoryId.COMBI,
};

export default config;
